import React from 'react';
import CommonLoading from '%app/js/common/components/material/Loading';
import PayseraReactSpinner from '%app/js/common/components/PayseraReactSpinner';

function Loading() {
    return (
        <CommonLoading renderOnLoad={<PayseraReactSpinner />} />
    );
}

export default React.memo(Loading);
